import React from 'react'
import { Bar } from 'react-chartjs-2'
import { Chart as ChartJS } from 'chart.js/auto'

function BarChart ({ chartData }, { plotOptions }) {
  return <Bar data={chartData} options={plotOptions} />
}

export default BarChart
